import styled from 'styled-components';

const Wrapper = styled.article`
  background: #ffffff;
  height: 100%;
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
  transition: all 0.4s ease;

  &:hover {
    border-color: rgba(107, 123, 92, 0.2);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }

  .product-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    text-decoration: none;
    color: inherit;
  }

  .container {
    position: relative;
    background: #f9fafb;
    overflow: hidden;
    padding-bottom: 100%; /* 1:1 aspect ratio */
    height: 0;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    transition: transform 0.6s ease;
  }

  /* Product badges */
  .badges {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    z-index: 10;
  }

  @media (min-width: 768px) {
    .badges {
      top: 0.75rem;
      left: 0.75rem;
      gap: 0.5rem;
    }
  }

  .badge {
    padding: 0.25rem 0.5rem;
    border-radius: 9999px;
    font-size: 0.625rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  @media (min-width: 768px) {
    .badge {
      padding: 0.25rem 0.625rem;
      font-size: 0.6875rem;
    }
  }

  .badge-new {
    background: var(--clr-olive, #6b7b5c);
    color: #ffffff;
  }

  .badge-sale {
    background: #ef4444;
    color: #ffffff;
  }

  .badge-bestseller {
    background: var(--clr-gold, #C9A962);
    color: #1f2937;
  }

  /* Action Buttons - Heart and Eye */
  .action-buttons {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    z-index: 10;
    opacity: 1;
    transform: translateX(0);
    transition: all 0.3s ease;
  }

  @media (min-width: 768px) {
    .action-buttons {
      top: 0.75rem;
      right: 0.75rem;
      opacity: 0;
      transform: translateX(10px);
    }
    .action-buttons.visible {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .action-btn {
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.95);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    color: #6b7280;

    &:hover {
      background: #ffffff;
      transform: scale(1.1);
    }
  }

  @media (min-width: 768px) {
    .action-btn {
      width: 2.25rem;
      height: 2.25rem;
    }
  }

  .wishlist-btn.active {
    background: #fef2f2;
    color: #ef4444;
  }

  .quickview-btn:hover {
    color: var(--clr-olive, #6b7b5c);
  }

  /* Quick Add Button - Desktop only */
  .quick-add {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.75rem;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
    display: none;
  }

  @media (min-width: 768px) {
    .quick-add {
      display: block;
    }
  }

  .quick-add.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .quick-add-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: var(--clr-olive, #6b7b5c);
    border: none;
    border-radius: 0.5rem;
    color: #ffffff;
    font-family: var(--font-body), system-ui, sans-serif;
    font-size: 0.8125rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 4px 12px rgba(107, 123, 92, 0.3);

    &:hover {
      background: #5a6a4c;
    }
  }

  /* Footer */
  footer {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0.75rem;
  }

  @media (min-width: 768px) {
    footer {
      padding: 1rem;
    }
  }

  /* Category label */
  .category-label {
    display: block;
    font-size: 0.625rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--clr-olive, #6b7b5c);
    margin-bottom: 0.25rem;
  }

  @media (min-width: 768px) {
    .category-label {
      font-size: 0.6875rem;
      margin-bottom: 0.375rem;
    }
  }

  footer h5 {
    font-family: 'Playfair Display', var(--font-display), serif;
    font-size: 0.875rem;
    font-weight: 600;
    color: #111718;
    margin: 0 0 0.375rem 0;
    min-height: 2.6em;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: color 0.2s;
  }

  @media (min-width: 768px) {
    footer h5 {
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }
  }

  .product-card:hover footer h5 {
    color: var(--clr-olive, #6b7b5c);
  }

  /* Rating */
  .rating {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    margin-bottom: 0.5rem;
  }

  .stars {
    display: flex;
    align-items: center;
    gap: 0.125rem;
  }

  .stars svg.filled {
    color: var(--clr-gold, #C9A962);
  }

  .stars svg.empty {
    color: #d1d5db;
  }

  .review-count {
    font-size: 0.625rem;
    color: #9ca3af;
  }

  @media (min-width: 768px) {
    .review-count {
      font-size: 0.6875rem;
    }
  }

  /* Price */
  .price-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    min-height: 1.4rem;
  }

  @media (min-width: 768px) {
    .price-container {
      margin-bottom: 0;
    }
  }

  .price-container span:first-child {
    font-size: 0.875rem;
    font-weight: 600;
    color: #111718;
  }

  @media (min-width: 768px) {
    .price-container span:first-child {
      font-size: 1rem;
    }
  }

  .original-price {
    text-decoration: line-through;
    color: #9ca3af;
    font-size: 0.75rem !important;
    font-weight: 400 !important;
  }

  .sale-price {
    color: #111718 !important;
  }

  .from-label {
    font-size: 0.7rem !important;
    font-weight: 500 !important;
    color: var(--clr-olive, #6b7b5c) !important;
    text-transform: lowercase;
  }

  @media (min-width: 768px) {
    .from-label {
      font-size: 0.75rem !important;
    }
  }

  /* Mobile Add to Cart Button */
  .mobile-add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    width: 100%;
    padding: 0.5rem 0.75rem;
    background: var(--clr-olive, #6b7b5c);
    border: none;
    border-radius: 0.375rem;
    color: #ffffff;
    font-family: var(--font-body), system-ui, sans-serif;
    font-size: 0.75rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-top: auto;

    &:active {
      transform: scale(0.98);
    }
  }

  @media (min-width: 768px) {
    .mobile-add-btn {
      display: none;
    }
  }

  footer p {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    margin: 0;
    letter-spacing: 0;
  }
`;

export default Wrapper;
